import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { SEO } from "@/components/common/SEO";
import { COMPANY } from "@/i18n/translations";

export default function Privacy() {
  const { t } = useLang();
  const sections = t("privacy.sections");

  return (
    <div data-testid="privacy-page">
      <SEO title={`${t("privacy.title")} | ${COMPANY.brand}`} description={t("privacy.intro")} />
      <section className="bg-white py-20 lg:py-28">
        <div className="container-orion max-w-3xl">
          <div className="text-eyebrow">{t("footer.legal")}</div>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl tracking-tighter font-medium leading-tight text-slate-900">
            {t("privacy.title")}
          </h1>
          <p className="mt-3 text-sm text-slate-500">{t("privacy.lastUpdated")}</p>
          <p className="mt-8 text-slate-600 leading-relaxed">{t("privacy.intro")}</p>
          <div className="mt-12 space-y-10">
            {sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-heading text-xl font-medium text-slate-900">{s.heading}</h2>
                <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
